<template>
  <div class="app__start">
    <div class="app__diamond app__diamond--top app__diamond--green"></div>
    <div class="app__start--content" v-html="step.content"></div>
    <div class="app__diamond app__diamond--bottom app__diamond--red"></div>
  </div>
</template>

<script>

import EventBus from "../../event-bus.js";

export default {
  props: ['step', 'currentStep'],
  data: () => ({
    active: false
  }),
  mounted() {
    setTimeout(() => {
      EventBus.$emit('SET_STEP', this.currentStep + 1);
    }, 1500);
  }
}
</script>